import type { MindScene } from "@rscircuit/mind-canvas";

/** True when `v` looks like mind-scene/1.x JSON. Never treat DEMO_SCENE as a project fallback. */
export function isMindScene(v: unknown): v is MindScene {
  if (v == null || typeof v !== "object" || Array.isArray(v)) return false;
  const rec = v as Record<string, unknown>;
  if (typeof rec.version !== "string" || !rec.version.startsWith("mind-scene")) return false;
  if (rec.modules != null && !Array.isArray(rec.modules)) return false;
  return true;
}

/** Architecture projection fixture. Sibling leaves so architecture view is not a single sheet card. */
export const DEMO_SCENE: MindScene = {
  version: "mind-scene/1.1",
  view: "architecture",
  goal: "AD9152 EVT1 analog + clock prototype (projection)",
  modules: [
    {
      name: "AD9152_DUT",
      role: "dac",
      intent: "Dual 16-bit 2.25 GSPS",
      mpn: "AD9152BCPZ",
      kind: "leaf",
      x: 320,
      y: 40,
      w: 200,
      h: 110,
      color: "#2f6fed",
      ports: [
        { name: "CLK", kind: "clock", direction: "in", side: "left" },
        { name: "IOUT", kind: "analog", direction: "out", side: "right" },
        { name: "VDD", kind: "power", direction: "in", side: "top" },
      ],
    },
    {
      name: "ClockTree",
      role: "clock",
      intent: "Low-jitter buffer",
      kind: "leaf",
      x: 40,
      y: 48,
      w: 180,
      h: 90,
      color: "#22c55e",
      ports: [{ name: "CLK", kind: "clock", direction: "out", side: "right" }],
    },
    {
      name: "BiasNet",
      role: "analog",
      intent: "IOUT termination",
      kind: "leaf",
      x: 560,
      y: 48,
      w: 160,
      h: 90,
      color: "#f59e0b",
      ports: [{ name: "IOUT", kind: "analog", direction: "in", side: "left" }],
    },
    {
      name: "USB_Power",
      role: "power",
      intent: "12V + 5V rails",
      kind: "leaf",
      x: 280,
      y: 200,
      w: 180,
      h: 90,
      color: "#c0392b",
      ports: [{ name: "VDD", kind: "power", direction: "out", side: "top" }],
    },
  ],
  links: [
    { from: "ClockTree.CLK", to: "AD9152_DUT.CLK", net: "CLK", layer: "clock" },
    { from: "AD9152_DUT.IOUT", to: "BiasNet.IOUT", net: "IOUT", layer: "analog" },
    { from: "USB_Power.VDD", to: "AD9152_DUT.VDD", net: "VDD", layer: "power", isPower: true },
  ],
};
